var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSmartlockKeypadHold = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M271.17 158.84C281.07 158.84 289.1 166.87 289.1 176.77C289.1 240.09 289.1 412.11 289.1 475.43C289.1 485.33 281.07 493.36 271.17 493.36C232.52 493.36 134.51 493.36 95.87 493.36C85.96 493.36 77.93 485.33 77.93 475.43C77.93 412.11 77.93 240.09 77.93 176.77C77.93 166.87 85.96 158.84 95.87 158.84C134.51 158.84 232.52 158.84 271.17 158.84Z",
    id: "iYmsJg4u"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.56 172.79C260.82 172.79 274.81 186.78 274.81 204.04C274.81 258.4 274.81 390.23 274.81 444.59C274.81 461.85 260.82 475.84 243.56 475.84C213.16 475.84 153.2 475.84 122.8 475.84C105.54 475.84 91.56 461.85 91.56 444.59C91.56 390.23 91.56 258.4 91.56 204.04C91.56 186.78 105.54 172.79 122.8 172.79C153.2 172.79 213.16 172.79 243.56 172.79Z",
    id: "b1LzgwjPJW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.38 198.17C196.38 205.46 190.47 211.37 183.18 211.37C175.9 211.37 169.98 205.46 169.98 198.17C169.98 190.89 175.9 184.97 183.18 184.97C190.47 184.97 196.38 190.89 196.38 198.17Z",
    id: "aJ1BNGU1o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.72 270.61C145.72 281.82 136.62 290.91 125.41 290.91C114.21 290.91 105.11 281.82 105.11 270.61C105.11 259.4 114.21 250.3 125.41 250.3C136.62 250.3 145.72 259.4 145.72 270.61Z",
    id: "c1f93f4yHy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.35 270.09C269.35 286.22 256.25 299.31 240.13 299.31C224 299.31 210.9 286.22 210.9 270.09C210.9 253.96 224 240.87 240.13 240.87C256.25 240.87 269.35 253.96 269.35 270.09Z",
    id: "a7Hil4P5i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.49 270.61C203.49 281.82 194.39 290.91 183.18 290.91C171.97 290.91 162.88 281.82 162.88 270.61C162.88 259.4 171.97 250.3 183.18 250.3C194.39 250.3 203.49 259.4 203.49 270.61Z",
    id: "hOstmIo2X"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.71 270.61C260.71 281.82 251.61 290.91 240.4 290.91C229.2 290.91 220.1 281.82 220.1 270.61C220.1 259.4 229.2 250.3 240.4 250.3C251.61 250.3 260.71 259.4 260.71 270.61Z",
    id: "h1vLXXsC6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.72 330.36C145.72 341.56 136.62 350.66 125.41 350.66C114.21 350.66 105.11 341.56 105.11 330.36C105.11 319.15 114.21 310.05 125.41 310.05C136.62 310.05 145.72 319.15 145.72 330.36Z",
    id: "b3Bxs0tpjI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.49 330.36C203.49 341.56 194.39 350.66 183.18 350.66C171.97 350.66 162.88 341.56 162.88 330.36C162.88 319.15 171.97 310.05 183.18 310.05C194.39 310.05 203.49 319.15 203.49 330.36Z",
    id: "b1n9Gg4J7H"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.71 328.32C260.71 339.53 251.61 348.63 240.4 348.63C229.2 348.63 220.1 339.53 220.1 328.32C220.1 317.12 229.2 308.02 240.4 308.02C251.61 308.02 260.71 317.12 260.71 328.32Z",
    id: "f7iQQkqR8N"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.45 382.99C145.45 394.2 136.35 403.3 125.14 403.3C113.94 403.3 104.84 394.2 104.84 382.99C104.84 371.79 113.94 362.69 125.14 362.69C136.35 362.69 145.45 371.79 145.45 382.99Z",
    id: "a2QBgzes92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.92 382.99C206.92 394.2 197.82 403.3 186.62 403.3C175.41 403.3 166.31 394.2 166.31 382.99C166.31 371.79 175.41 362.69 186.62 362.69C197.82 362.69 206.92 371.79 206.92 382.99Z",
    id: "c1uytbQ0FI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.44 382.99C260.44 394.2 251.34 403.3 240.13 403.3C228.93 403.3 219.83 394.2 219.83 382.99C219.83 371.79 228.93 362.69 240.13 362.69C251.34 362.69 260.44 371.79 260.44 382.99Z",
    id: "ccWwdFeM6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.45 433.6C145.45 444.81 136.35 453.91 125.14 453.91C113.94 453.91 104.84 444.81 104.84 433.6C104.84 422.4 113.94 413.3 125.14 413.3C136.35 413.3 145.45 422.4 145.45 433.6Z",
    id: "c3AriMMfJk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.92 433.6C206.92 444.81 197.82 453.91 186.62 453.91C175.41 453.91 166.31 444.81 166.31 433.6C166.31 422.4 175.41 413.3 186.62 413.3C197.82 413.3 206.92 422.4 206.92 433.6Z",
    id: "ai9lO4y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.44 433.6C260.44 444.81 251.34 453.91 240.13 453.91C228.93 453.91 219.83 444.81 219.83 433.6C219.83 422.4 228.93 413.3 240.13 413.3C251.34 413.3 260.44 422.4 260.44 433.6Z",
    id: "a6LX4nOg12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14 138.03L240.13 138.03L240.13 158.84L125.14 158.84L125.14 138.03Z",
    id: "g7yXK4Hwb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.88 99.78L203.49 99.78L203.49 138.03L162.88 138.03L162.88 99.78Z",
    id: "g1zEu8GIXh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "f2SejPDcDq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.12 417.99C277.31 414.8 266.19 412.81 261.73 412.02C258.45 411.43 255.06 411.94 252.09 413.46C249.23 414.92 252.82 413.08 251.86 413.57C244.17 417.52 241.25 427.03 245.4 434.61C246.06 435.82 243.86 431.8 245.38 434.56C247.52 438.48 251.06 441.45 255.3 442.88C271.48 448.34 316.29 463.47 333.18 469.18C335.19 469.86 337.07 470.86 338.74 472.16C340.28 473.36 340.19 473.29 341.18 474.07C344.67 476.78 348.56 478.91 352.71 480.4C354.64 481.08 352.47 480.31 353.97 480.85C359.52 482.83 365.36 483.84 371.25 483.84C371.85 483.84 369.39 483.84 371.15 483.84C373.23 483.84 375.3 483.55 377.3 482.98C380.67 482.01 387.28 480.13 390.52 479.2C392.93 478.51 395.16 477.33 397.08 475.73C401.27 472.24 408.3 466.38 411.83 463.44C415.96 460 420.35 456.89 424.98 454.15C430.29 451 442.75 443.61 448.93 439.94C450.64 438.92 452.03 437.44 452.92 435.65C453.44 434.61 453.26 434.98 453.68 434.13C454.88 431.74 455.2 429 454.6 426.4C453.75 422.71 453.03 419.56 452.4 416.84C451.04 410.92 449.23 405.1 447 399.45C447 399.45 447 399.45 447 399.45C443.77 391.26 440.9 388.23 435.96 379.77C426.23 363.07 411.15 338.18 390.71 305.11C387.82 300.44 382.53 297.83 377.06 298.38C375.11 298.58 378.85 298.2 377.06 298.38C370.98 299 365.61 302.64 362.79 308.07C362.31 309 363.52 306.66 362.58 308.48C361.22 311.1 361.31 314.23 362.82 316.76C364.15 319.01 367.5 324.64 372.86 333.65C364.15 319.17 358.71 310.12 356.54 306.5C354.88 303.74 352.6 301.41 349.87 299.7C349.39 299.41 350.13 299.87 349.16 299.26C348.06 298.57 346.81 298.15 345.51 298.05C344.11 297.93 345.56 298.05 345.08 298.01C340.89 297.67 336.75 299.14 333.72 302.06C332.66 303.08 333.34 302.43 332.05 303.66C329.75 305.88 328.45 308.94 328.45 312.14C328.45 313.39 328.45 312.82 328.45 314.24C328.45 316.97 329.16 319.65 330.51 322.02C331.8 324.27 335.03 329.92 340.19 338.95C332.81 326.03 328.19 317.95 326.35 314.72C324.97 312.32 323.32 310.1 321.41 308.1C320.9 307.57 322.23 308.97 321.72 308.43C319.88 306.5 317.4 305.3 314.74 305.06C312.46 304.85 315.91 305.17 315.17 305.1C307.98 304.43 301.06 308.04 297.49 314.32C296.63 315.83 299.34 311.06 298.34 312.82C295.16 318.42 295.21 325.3 298.49 330.84C301.38 335.73 308.61 347.96 320.18 367.52C292.14 320.13 274.62 290.51 267.61 278.67C265.67 275.39 262.7 272.84 259.17 271.43C258.52 271.17 260.83 272.09 259.88 271.71C257.33 270.69 254.5 270.58 251.88 271.4C250.45 271.84 251.49 271.52 250.37 271.86C246.65 273.02 243.17 274.85 240.11 277.28C239.25 277.96 241.71 276.01 240.95 276.61C237.69 279.2 235.7 283.06 235.48 287.22C235.4 288.82 235.57 285.57 235.51 286.79C235.23 292.27 236.59 297.71 239.42 302.42C248.92 318.2 272.66 357.65 310.65 420.77L295.12 417.99Z",
    id: "h3UPuWNPnu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.96 223.28C352.19 223.03 352.33 222.87 352.39 222.8C357.1 217.53 360.31 211.4 362.02 204.96C365.74 190.97 362.37 175.5 351.96 164.19C351.96 164.19 351.96 164.19 351.96 164.19",
    id: "a7JGCYPsd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.96 234.65C362.29 234.29 362.5 234.07 362.59 233.98C369.46 226.68 374.13 218.2 376.63 209.28C382.05 189.9 377.14 168.49 361.96 152.83C361.96 152.83 361.96 152.83 361.96 152.83",
    id: "bLkjMOraX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.78 212.37C340.95 212.21 341.05 212.11 341.09 212.08C344.53 208.85 346.87 205.1 348.11 201.17C350.82 192.61 348.37 183.15 340.78 176.23C340.78 176.23 340.78 176.23 340.78 176.23",
    id: "aDTDTXTZo"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iYmsJg4u",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iYmsJg4u",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1LzgwjPJW",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1LzgwjPJW",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aJ1BNGU1o",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aJ1BNGU1o",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1f93f4yHy",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1f93f4yHy",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow10343959",
    x: 201.9,
    y: 231.87,
    width: 77.44,
    height: 77.44,
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    result: "afterOffset"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#cc3030",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "afterOffset",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    operator: "dilate",
    radius: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "out"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.35 270.09C269.35 286.22 256.25 299.31 240.13 299.31C224 299.31 210.9 286.22 210.9 270.09C210.9 253.96 224 240.87 240.13 240.87C256.25 240.87 269.35 253.96 269.35 270.09Z",
    id: "a2xAnTCfdt",
    fill: "white",
    fillOpacity: 1,
    filter: "url(#shadow10343959)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7Hil4P5i",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7Hil4P5i",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 2,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hOstmIo2X",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hOstmIo2X",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h1vLXXsC6B",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h1vLXXsC6B",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3Bxs0tpjI",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3Bxs0tpjI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1n9Gg4J7H",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1n9Gg4J7H",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f7iQQkqR8N",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f7iQQkqR8N",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2QBgzes92",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2QBgzes92",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1uytbQ0FI",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1uytbQ0FI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ccWwdFeM6",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ccWwdFeM6",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3AriMMfJk",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3AriMMfJk",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ai9lO4y",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ai9lO4y",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6LX4nOg12",
    opacity: 1,
    fill: "#0c9577",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6LX4nOg12",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g7yXK4Hwb",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g7yXK4Hwb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g1zEu8GIXh",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g1zEu8GIXh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f2SejPDcDq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#a6f09a",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h3UPuWNPnu",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h3UPuWNPnu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 2,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7JGCYPsd3",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#0c9577",
    strokeWidth: 4,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bLkjMOraX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#0c9577",
    strokeWidth: 4,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aDTDTXTZo",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#0c9577",
    strokeWidth: 4,
    strokeOpacity: 1
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSmartlockKeypadHold, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/smartlock-keypad-hold.9fab5f4c.svg";
export { ForwardRef as ReactComponent };